{
  "shcCP": {
    "filters": {
      "sort": {
        "label": "Sortuj:",
        "priceASC": "cena od najniższej",
        "priceDESC": "cena od najwyższej",
        "nameASC": "nazwa od a",
        "nameDESC": "nazwa od z"
      }
    },
    "emptyProducts": "Brak produktów",
    "catalog": {
      "page": "strona"
    }
  }
}
